import { createFileRoute, redirect, notFound } from '@tanstack/react-router';
import { SidebarLayout } from '@/components/layout/SidebarLayout';
import { navigationConfig } from '@/utils/navigation';
import { useNavigationItems } from '@/hooks/useNavigation';
import { useTranslation } from 'react-i18next';
import '@/assets/scss/page-transitions.scss';
import { isAdminEquivalentRole, normalizeUserRole } from '@/utils/authz';
import { USER_ROLES } from '@/constants/roles';

/**
 * Client area route. Allowed global roles: CUSTOMER and admin-equivalent (ADMIN, DEVELOPER).
 */
export const Route = createFileRoute('/client')({
  component: ClientLayout,
  beforeLoad: ({ context, location }) => {
    // Redirect unauthenticated users to login page (null or falsy auth)
    if (!context?.auth) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href } as any
      });
    }

    const role = normalizeUserRole(context.auth?.role);
    if (role !== USER_ROLES.CUSTOMER && !isAdminEquivalentRole(role)) {
      throw notFound();
    }
  }
});

/**
 * Client layout with sidebar using configuration from navigationConfig with dynamic module integration.
 * Applies custom className for styling.
 */
function ClientLayout() {
  const config = navigationConfig.client;
  const navigationItems = useNavigationItems('client');
  const { t } = useTranslation('navigation');

  return (
    <SidebarLayout
      context="client"
      title={t(config.titleKey)}
      navigationItems={navigationItems}
      expandedSiderWidth={config.expandedWidth}
      collapsedSiderWidth={config.collapsedWidth}
      className="client-layout"
    />
  );
}
